import { store } from './store';
import authActions from '@iso/redux/auth/actions';
// import mqttActions from '@iso/redux/mqtt/actions';
// eslint-disable-next-line
export default () =>
  new Promise(() => {
    store.dispatch(authActions.checkAuthorization());
    // store.dispatch(mqttActions.connectMqtt());
  });
